<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Marketplaces</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span
                v-if="countFilter > 0"
                class="badge badge-light"
              >{{countFilter}}</span>
            </button>
            <b-button
              v-if="countFilter > 0"
              variant="primary"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </b-button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Marketplaces</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6
                    class="m-0"
                  >{{pagination.TotalItems | number}} {{pagination.TotalItems > 1 ? " itens" : "item"}}</h6>
                  <div class="dropdown m-0" :class="window.width < 1880 ? 'dropleft' : ''">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : '' "
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader :small="true" :isLoading="loadingReport"></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loading"></loader>
              <table class="table mb-0" v-if="!loading">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">{{labelName}}</th>
                    <th scope="col" class="border-0">Origem</th>
                    <th scope="col" class="border-0 text-left">Localidade</th>
                    <th scope="col" class="border-0">Data do cadastro</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(merchant, index) in merchants" :key="index">
                    <td></td>
                    <td class="text-left td-with-subs">
                      <div>{{merchant.Name | substring(50)}}</div>
                      <span>{{merchant.Identity | identity }}</span>
                    </td>
                    <td>
                      <div>{{merchant.SourceDescription}}</div>
                      <span
                        class="td-span-style"
                        v-if="merchant.Partner.PartnerType.Name != null && merchant.Partner.PartnerType.Name != undefined && merchant.Partner.PartnerType.Name != ''"
                      >PARCEIRO {{merchant.Partner.PartnerType.Name | upper}}</span>
                    </td>
                    <td
                      v-if="merchant.Address.CityName != undefined && merchant.Address.CityName != ''"
                      class="text-left"
                    >{{merchant.Address.CityName}} / {{merchant.Address.StateInitials}}</td>
                    <td v-else></td>
                    <td class="td-with-subs">
                      <div>{{merchant.CreatedDate | date }}</div>
                      <span>{{merchant.CreatedDate | date('HH:mm:ss') }}</span>
                    </td>
                    <td>
                      <button
                        class="btn btn-outline-secondary"
                        type="button"
                        v-on:click="OpenMerchantSubAccount($event, merchant.Id)"
                        v-if="merchant.IsMerchantRoot"
                      >
                        <i class="fas fa-store-alt"></i> Subcontas
                      </button>
                      <button
                        class="btn btn-outline-secondary"
                        type="button"
                        v-on:click="OpenProfit($event, merchant.Id)"
                        v-if="!merchant.IsMerchantRoot"
                      >
                        <i class="fas fa-dollar-sign mr-1"></i> Faturamento
                      </button>
                    </td>
                  </tr>
                  <tr v-if="merchants == undefined || merchants == null || merchants.length == 0">
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="mProfit"
      size="huge"
      title="Faturamento"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <profit :dashboard="true" :idMerchantDashboard="idMerchantDashboard" />
        </d-col>
      </d-form-row>
      <template slot="modal-footer" slot-scope="{cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
      </template>
    </b-modal>
    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            v-bind:placeholder="labelIdentity"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsRemoved" :value="null">
            <option :value="false">Ativos</option>
            <option :value="true">Inativos</option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IdPartner" :value="null">
            <option :value="null" selected>Parceiro</option>
            <option :value="0" selected>Sem parceiro</option>
            <option
              v-for="partner in partners"
              v-bind:key="partner.Id"
              v-bind:value="partner.Id"
            >{{partner.Name}}</option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.IsTest" :value="null">
            <option :value="false">Clientes</option>
            <option :value="true">Clientes de teste</option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.AddressFilter.StateFilter.Initials" :value="null">
            <option :value="null" selected>Estado</option>
            <option
              v-for="state in statesFilter"
              v-bind:key="state.Initials"
              v-bind:value="state.Initials"
            >{{state.Name}}</option>
          </d-select>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
    <a
      href="#"
      class="btn-float primary"
      v-b-tooltip.hover
      title="Voltar"
      v-on:click="BackMarketplaces($event)"
      v-if="!isMerchantRoot"
    >
      <i class="fa fa-reply"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import profit from "./profit";
export default {
  name: "marketplaces",
  components: {
    profit
  },
  data: function() {
    return {
      countFilter: 1,
      isMerchantRoot: true,
      idMerchantRoot: 0,
      idMerchantDashboard: 0,
      codeMerchantType: "3",
      labelIdentity: "CPF/CNPJ",
      labelName: "Cliente",
      loading: false,
      loadingReport: false,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      filter: {
        Name: null,
        Identity: null,
        IdPartner: null,
        IsRemoved: false,
        IsTest: false,
        IsMerchantRoot: true,
        CodeMerchantType: "3",
        AddressFilter: {
          StateFilter: {
            Initials: null
          }
        }
      },
      idMerchant: 0,
      merchants: [],
      cities: [],
      currentTaxes: [],
      hasPartner: true,
      partners: [],
      statesFilter: [],
      window: {
        width: 0,
        height: 0
      }
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function() {
      this.ListMerchant();
    },
    "pagination.RowsPerPage": function() {
      this.ListMerchant();
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.ListPartner();
    this.ListState();
    this.ListMerchant();
  },
  methods: {
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListMerchant();
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ListMerchant: function() {
      this.countFilter = 0;
      if (hasValue(this.filter.IdPartner)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.IsRemoved)) this.countFilter++;
      if (hasValue(this.filter.IsTest)) this.countFilter++;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.AddressFilter.StateFilter.Initials))
        this.countFilter++;
      this.loading = true;
      this.filter.IsMerchantRoot = this.isMerchantRoot;
      this.filter.CodeMerchantType = this.codeMerchantType;
      let params = this.GetParamsData();
      this.$store
        .dispatch("ListMerchant", { params: params })
        .then(response => {
          this.merchants = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os clientes",
            error
          );
        })
        .finally(() => (this.loading = false));
    },
    OpenMerchantSubAccount: function(e, idMerchant) {
      e.preventDefault();
      this.idMerchantRoot = idMerchant;
      this.isMerchantRoot = false;
      this.codeMerchantType = null;
      this.ResetFilter();
    },
    GetParamsData: function(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Identity": this.filter.Identity,
        "Object.IsRemoved": this.filter.IsRemoved,
        "Object.IsTest": this.filter.IsTest,
        "Object.IsMerchantRoot": this.filter.IsMerchantRoot,
        "Object.MerchantType.Code": this.filter.CodeMerchantType,
        "Object.Partner.Id": this.filter.IdPartner,
        "Object.IdMerchantRoot": this.idMerchantRoot,
        "Object.Name": this.filter.Name,
        "Object.Address.State.Initials": this.filter.AddressFilter.StateFilter
          .Initials
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },
    GetReport: function(ev) {
      ev.preventDefault();
      this.loadingReport = true;
      this.filter.IsMerchantRoot = this.isMerchantRoot;
      this.filter.CodeMerchantType = this.codeMerchantType;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ReportMerchant", { params: data })
        .then(response => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    ResetFilter: function() {
      this.filter = {
        Name: null,
        Identity: null,
        IdPartner: null,
        IsRemoved: false,
        IsTest: false,
        IsMerchantRoot: true,
        AddressFilter: {
          StateFilter: {
            Initials: null
          }
        }
      };
      this.ListMerchant();
    },
    ListPartner: function() {
      let data = { OrderByColumn: "Name" };
      this.$store
        .dispatch("ListPartner", { params: data })
        .then(response => {
          this.partners = response.Objects;
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter lista de parceiros",
            error
          );
        });
    },
    ListState: function() {
      this.$store.dispatch("ListState", { idCountry: 24 }).then(response => {
        this.statesFilter = response;
      });
    },
    OpenProfit: function(e, idMerchant) {
      e.preventDefault();
      this.idMerchantDashboard = idMerchant;
      this.$bvModal.show("mProfit");
    },
    BackMarketplaces: function() {
      this.idMerchantRoot = 0;
      this.isMerchantRoot = true;
      this.codeMerchantType = "3";
      this.ResetFilter();
    }
  }
};
</script>

<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.td-span-style {
  font-size: 9pt;
  opacity: 0.75;
}
.tr-hidden {
  border-top: hidden;
}
</style>
<style>
.modal .modal-huge {
  max-width: 1000px;
  width: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/marketplaces.vue